import styles from './holding-type-badges.module.scss';
import MarkdownParser from 'components/rich-text/markdown-parser';
import { format } from 'date-fns';
import { useTranslations } from 'next-intl';
import Badge from 'components/badge';
//https://next-intl.dev/docs/environments/server-client-components#async-components
//UseTranslations will work regardless of if this is a server or client component

const HoldingBadgeTemplate = ({ title, message, variant }: TemplateProps) => {
	if (variant === 'small') {
		return (
			<Badge
				text={title}
				color={'var(--color-met-red-medium)'}
				backgroundColor="#ecc3b21a"
			/>
		);
	}

	return (
		<div className={styles.badge}>
			<div className={styles.title}>
				<MarkdownParser>{title}</MarkdownParser>
			</div>
			<MarkdownParser>{message}</MarkdownParser>
		</div>
	);
};

interface TemplateProps {
	message?: string;
	title: string;
	variant?: 'small' | 'modal';
}

export const HoldingTypeBadges = ({
	extendedStatuses,
	deaccessionDate,
	variant,
}: IProps) => {
	const t = useTranslations('collection.holdingTypes');
	//https://stackoverflow.com/questions/4310953/invalid-date-in-safari
	const date = deaccessionDate
		? format(deaccessionDate.replace(/-/g, '/'), 'LLLL yyyy')
		: null;

	// this array is needed because it helps keep the order they should display in (Restituted first)
	const supportedTypes = [
		'restituted',
		'promised_gift',
		'returned_loan',
		'exhibition_loan',
		'department_loan',
		// not implemented yet: deaccessioned_not_yet_restituted, non_accessioned, unaccessioned, unassigned, accessioned, lauder_cubist_collection
	];

	const data = {
		exhibition_loan: { title: t('loan.title'), message: t('loan.message') },
		department_loan: { title: t('loan.title'), message: t('loan.message') },
		returned_loan: {
			title: t('returned.title'),
			message: t('returned.message'),
		},
		promised_gift: {
			title: t('promised.title'),
			message: t('promised.message'),
		},
		restituted: {
			title: t('restituted.title'),
			message: t('restituted.message', { date }),
		},
	};

	return (
		<div
			className={[
				styles.badges,
				variant === 'small' ? styles.small : '',
				variant === 'modal' ? styles.modal : '',
			].join(' ')}
		>
			{supportedTypes.map((type) => {
				if (extendedStatuses.includes(type)) {
					const { title, message } = data[type];
					return (
						<HoldingBadgeTemplate key={type} {...{ title, message, variant }} />
					);
				}
			})}
		</div>
	);
};

export interface IProps {
	deaccessionDate?: string;
	extendedStatuses: string[];
	variant?: 'small' | 'modal';
}

export default HoldingTypeBadges;
